//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import adres from '~/graphql/queries/adres.gql';

export default {
  name: 'Stap4',
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    maatwerkroute: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    errors: {
      address: ['', ''],
    },
  }),
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    async getAddress() {
      if (this.formData.praktijkgegevens) {
        for (let i = 0; i < this.formData.praktijkgegevens.length; i++) {
          const praktijkgegevens = this.formData.praktijkgegevens[i];
          if (praktijkgegevens.huisnummer && praktijkgegevens.postcode && praktijkgegevens.postcode.length === 6) {
            await this.$apollo.query({
              query: adres,
              variables: {
                postcode: praktijkgegevens.postcode,
                huisnummer: praktijkgegevens.huisnummer,
              },
            }).then((data) => {
              if (data?.data?.adres) {
                const adres = data.data.adres;
                const newPraktijkgegevens = JSON.parse(JSON.stringify(praktijkgegevens));
                newPraktijkgegevens.adres = adres?.straat ? adres.straat : '';
                newPraktijkgegevens.plaats = adres?.plaats ? adres.plaats : '';
                this.$emit('setPraktijkGegevens', i, newPraktijkgegevens);
                this.errors.address[i] = (!newPraktijkgegevens.adres || !newPraktijkgegevens.plaats) ? 'Adres niet gevonden' : '';

                this.formData = JSON.parse(JSON.stringify(this.formData));
              }
            }).catch((err) => {
              console.error(err);
            });
          }
        }
      }
    },
    submit(data) {
      this.$emit('submit', data);
    },
  },
};
